import api from "./api";
import API_URLS from "../../constants/api-urls";

export default class SupplierApi {
  create(data) {
    return api.post(API_URLS.URL.supplier, data);
  }
  getList(data) {
    return api.post(API_URLS.URL.getSupplierList, data);
  }
  getSupplier(id) {
    return api.get(API_URLS.URL.getSupplier.replace(":id", id));
  }
  updateSupplier(data) {
    return api.put(API_URLS.URL.updateSupplier.replace(":id", data?.id), data);
  }
  upload(file) {
    return api.post(API_URLS.URL.uploadFile, file);
  }
  delete(id) {
    return api.delete(API_URLS.URL.delete.replace(":id", id));
  }
}
